const options = {
  5: "bg-lime-100/5",
  10: "bg-lime-100/10",
  25: "bg-lime-100/25",
  50: "bg-lime-100/50",
  75: "bg-lime-100/75",
  90: "bg-lime-100/90",
  100: "bg-lime-100",
};

const from = {
  5: "from-lime-100/5",
  10: "from-lime-100/10",
  25: "from-lime-100/25",
  50: "from-lime-100/50",
  75: "from-lime-100/75",
  90: "from-lime-100/90",
  100: "from-lime-100",
};

export default function getBackgroundLime100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
